import { useNavigate } from "react-router-dom";
import { ActivePackagesDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { expeditionRoutes } from "../../../../../../router/routesConstants";
import ActionMenu from "../../../../../../components/actionMenu/ActionMenu";

function ClientAwbHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: ActivePackagesDataInterface;
}) {
  const navigate = useNavigate();

  const handleGetPackages = () => {
    if (itemId) {
      navigate(
        `${expeditionRoutes.activePackages}?idExpeditie=${itemId}&client=${crudData.client}`,
      );
    }
  };

  return (
    <ActionMenu
      items={[
        {
          id: "active-packages",
          label: "Colete active",
          icon: "PACKAGES",
          tooltip: itemId
            ? "Afiseaza coletele active ale acestei expeditii."
            : "Expeditia trebuie sa aiba un identificator pentru a afisa coletele.",
          disabled: !itemId,
          onClick: handleGetPackages,
        },
      ]}
      title={`AWB ${crudData.doc_trans}`}
      ariaLabel={`Actiuni pentru AWB ${crudData.doc_trans}`}
    />
  );
}

export default ClientAwbHistoryActionButtons;
